import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({

  selector: 'app-taxilon-search-passenger',

  templateUrl: './taxilon-search-passenger.component.html',

  styleUrls: ['./taxilon-search-passenger.component.css']

})

export class TaxilonSearchPassengerComponent implements OnInit {

  lst_Passenger: any[] = [];

  lst_Search: any[] = [];

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strFamily: new FormControl(''),

    strMobile: new FormControl(''),

    tiAvtive: new FormControl(-1),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private _mapService: MapService

  ) { }

  ngOnInit(): void {

  }

  async search_Passenger() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_User_ORG_Search`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Passenger = res;

    this.lst_Search = res;

  }

  async activation_User(item: any, index: number) {

    var model = {

      ...this.mdl_Search.value,

      iTaxiLon_User: item.iTaxiLon_User,

      bActive: !item.bActive

    }

    $.confirm({

      title: `آیا از ${model.bActive ? 'فعال کردن' : 'غیرفعال کردن'} کاربر اطمینان دارید؟`,

      content: '',

      type: 'green',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-success',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`TaxiLon_User_EnableDisable`, this._otherService.stringNumberToNumber(model))).data.toString());

            this._otherService.nonespinner();

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            this.lst_Passenger[index].bActive = model.bActive;

            this._tooltip.showSuccess(`وضعیت کاربر${model.bActive ? ' فعال ' : ' غیرفعال '} شد`)

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });



  }

  filter_list(val: any) {

    this.lst_Passenger = this.lst_Search.filter((el: any) => {

      return el?.strName?.includes(val.value) ||

        el.strFamily.includes(val.value) ||

        el.strMobile.includes(val.value) ||

        el.strSexComment.includes(val.value) ||

        el.strCityName.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Passenger = this.lst_Search;

    }

  }

  exportExcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'جستجوی مسافران.xlsx');
  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

  showMap(item: any) {

    // console.log(item)

    // this.mdl_Map.patchValue({

    //   strAddress: '',

    //   fLon: 51.3833554,

    //   fLat: 35.6770113,

    //   strSource: ''

    // })

    // this.showCustom_Map_2 = true;

  }

}
